import axiosInstance from "../clients/axiosClient";
import { CreateTagsRequest, ListTagsResponse, UpdateTagsRequest } from "../types/apiGeneratedTypes";
import { API_V1_PREFIX, TAGS_API_PREFIX } from "../utils/constants";

export const getTagsList = async (
  search?: string,
  sort_by?: string,
  sort_direction?: string
): Promise<ListTagsResponse> => {
  try {
    const params: any = {
      search: search || '',
    };

    if (sort_by) {params.sort_by = sort_by;}
    if (sort_direction) {params.sort_direction = sort_direction;}

    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${TAGS_API_PREFIX}list`,
      { params }
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const createTag = async (
  newTagRequestObject: CreateTagsRequest
) => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${TAGS_API_PREFIX}`,
      newTagRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateTag = async (
  tagRequestObject: UpdateTagsRequest
) => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${TAGS_API_PREFIX}`,
      tagRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
